import { TamanhoFraldaGeriatricaEnum } from 'graphql/types.generated'
import { conformToMask } from 'react-text-mask'
import { masks, onlyNumbersNonZeroLeft } from 'util/mask'

import AtestadoModel, { CidadaoAtestado } from '../components/model-atestado'
import { buildCid10Substring, buildNomeSubstring } from '../utils-atestado'

type SolicitacaoFraldasGeriatricasTextParams = {
  cidadao: CidadaoAtestado
  values?: AtestadoModel
}

const maskCpf = (cpf: string): string => conformToMask(cpf, masks.cpf, { guide: false }).conformedValue

const buildCpfSubstring = (cpf: string): string => `, portador(a) do CPF ${maskCpf(cpf)},`

const buildCnsSubstring = (cns: string): string => `, portador(a) do CNS ${cns},`

const buildCpfCnsSubstring = (cidadao: CidadaoAtestado, cpfCns: string | undefined, naoPossui: boolean): string => {
  if (cidadao.cpf) return buildCpfSubstring(cidadao.cpf)
  if (cidadao.cns) return buildCnsSubstring(cidadao.cns)
  if (naoPossui) return ''
  if (cpfCns?.length === 11) return buildCpfSubstring(cpfCns)
  if (cpfCns?.length === 15) return buildCnsSubstring(cpfCns)

  return ', portador(a) do CPF/CNS [CPF/CNS],'
}

const buildTamanhoFraldaSubstring = (tamanhoFralda: TamanhoFraldaGeriatricaEnum | undefined): string =>
  tamanhoFralda || '[Tamanho da fralda]'

const buildUnidadesPorDiaSubstring = (unidadesPorDia: number | undefined): string =>
  unidadesPorDia ? 'unidade'.pluralizeAndConcatValue(unidadesPorDia) : '[Recomendação diária] unidades'

const buildTotalUnidadesSubstring = (unidadesPorDia: number | undefined): string =>
  unidadesPorDia ? `${unidadesPorDia * 30}` : '[Total]'

export const getSolicitacaoFraldasGeriatricasText = ({
  cidadao,
  values,
}: SolicitacaoFraldasGeriatricasTextParams): string => {
  const nome = buildNomeSubstring(cidadao)
  const documento = buildCpfCnsSubstring(cidadao, values?.cpfCns, values?.naoPossui)
  const cid10 = buildCid10Substring(values?.cid10)
  const tamanhoFralda = buildTamanhoFraldaSubstring(values?.tamanhoFralda)
  const unidadesPorDia = buildUnidadesPorDiaSubstring(values?.unidadesPorDia)
  const totalUnidades = buildTotalUnidadesSubstring(values?.unidadesPorDia)

  return (
    `Atesto que o(a) Sr.(a) ${nome}${documento} ` +
    `encontra-se em acompanhamento de saúde de sua condição clínica${cid10} e, em decorrência disso, ` +
    `faz uso contínuo de fraldas geriátricas, tamanho ${tamanhoFralda}, ` +
    `com recomendação de aproximadamente ${unidadesPorDia} por dia, ` +
    `totalizando ${totalUnidades} unidades por mês.`
  )
}

export const parseUnidadesPorDia = (value: string): number | undefined => {
  const parsed = onlyNumbersNonZeroLeft(value)

  return parsed ? Number(parsed) : undefined
}
